import { ColorContextPadProvider } from './ColorContextPadProvider';
import { ColorPopupProvider } from './ColorPopupProvider';

export const BpmnColorPickerModule = {
    __init__: ['colorContextPadProvider', 'colorPopupProvider'],
    colorContextPadProvider: ['type', ColorContextPadProvider],
    colorPopupProvider: ['type', ColorPopupProvider],
};
